import { FederalAgeCategory, Gender } from '@shared/enums/domain.enum';

export const CATEGORY_LABELS: Record<FederalAgeCategory, string> = {
  [FederalAgeCategory.VETERAN]: 'Vétéran',
  [FederalAgeCategory.SENIOR]: 'Senior',
  [FederalAgeCategory.JUNIOR]: 'Junior',
  [FederalAgeCategory.CADET]: 'Cadet',
  [FederalAgeCategory.MINIME]: 'Minime',
  [FederalAgeCategory.BENJAMIN]: 'Benjamin',
};

export const CLASSIFICATION_LABELS: Record<string, string> = {
  ELITE: 'Élite',
  HONNEUR: 'Honneur',
  PROMOTION: 'Promotion',
};

export const GENDER_LABELS: Record<Gender, string> = {
  [Gender.MALE]: 'Homme',
  [Gender.FEMALE]: 'Femme',
};

export const RANK_COLORS: Record<number, string> = {
  1: 'bg-yellow-100 text-yellow-700 border-yellow-200',
  2: 'bg-slate-100 text-slate-600 border-slate-200',
  3: 'bg-orange-100 text-orange-700 border-orange-200',
};

export function formatDate(iso: string) {
  return new Date(iso).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
}
